// tape S01: probably mixtape manifest.
// Audio files are self-hosted MP3 (V0) under /probably/NN.mp3 — encoded from the
// WAV masters via scripts/encode-probably.sh. Display titles preserve the master
// glyphs; durations are baked in so the tracklist has no layout shift on load.

export interface Track {
  n: number
  title: string
  src: string
  duration: number // seconds
}

export const ALBUM = {
  title: 'probably',
  artist: 'vaguepost king',
  cover: '/probably/cover_sm.png',
  coverFull: '/probably/cover.png',
  soundcloud: 'https://soundcloud.com/vaguepostking/sets/probably',
  presave: 'https://distrokid.com/hyperfollow/vaguepostking/probably',
}

export const TRACKS: Track[] = [
  { n: 1, title: 'carrier wave novena', src: '/probably/01.mp3', duration: 150 },
  { n: 2, title: 'screwed sacrament ✟', src: '/probably/02.mp3', duration: 279 },
  { n: 3, title: 'cassette necromancy', src: '/probably/03.mp3', duration: 237 },
  { n: 4, title: 'empty heaven (angeldust)', src: '/probably/04.mp3', duration: 186 },
  { n: 5, title: 'vibe liquidation', src: '/probably/05.mp3', duration: 337 },
  { n: 6, title: 'dreamwall, dissolving', src: '/probably/06.mp3', duration: 362 },
  { n: 7, title: 'still here (recovered)', src: '/probably/07.mp3', duration: 225 },
  { n: 8, title: 'BUILT WRONG ON PURPOSE', src: '/probably/08.mp3', duration: 208 },
  { n: 9, title: 'ACTIVE MEASURES: deployed', src: '/probably/09.mp3', duration: 295 },
  { n: 10, title: 'COUNT OVERFLOW ⛧', src: '/probably/10.mp3', duration: 206 },
  { n: 11, title: 'throne of the green frequency', src: '/probably/11.mp3', duration: 216 },
  { n: 12, title: 'palimpsest requiem ∴ probably', src: '/probably/12.mp3', duration: 212 },
]

export function fmtTime(sec: number): string {
  if (!isFinite(sec) || sec < 0) return '--:--'
  const m = Math.floor(sec / 60)
  const s = Math.floor(sec % 60)
  return `${m}:${String(s).padStart(2, '0')}`
}

export function totalRuntime(): number {
  return TRACKS.reduce((a, t) => a + t.duration, 0)
}
